import { action, observable } from 'mobx';

import { GetCurrentLoginInformations } from '../services/session/dto/getCurrentLoginInformations';
import sessionService from '../services/session/sessionService';

declare var abp: any;
class SessionStore {
  @observable currentLogin: GetCurrentLoginInformations = new GetCurrentLoginInformations();
  @observable currentName: string = "";
  @action
  async getCurrentLoginInformations() {
    try {
      let result = await sessionService.getCurrentLoginInformations();
      this.currentName = result.user?.fullName;
      this.currentLogin = result;
    } catch (error) {
      console.error(error);
    }
  }
}

export default SessionStore;
